"use strict";

var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NEW_USER_FORM = {
  title: 'Add a new member',
  saveLabel: 'Add',
  fields: {
    id: {
      order: 1,
      kind: 'email',
      label: 'Email'
    },
    role: {
      order: 2,
      kind: 'choice',
      kind_options: {
        values: {
          guest: 'Guest (only has access to the workspaces)',
          member: 'Member (can see other members)',
          organizer: 'Organizer (can see other members, create and join workspaces)',
          admin: 'Administrator (can create workspaces and promote other members)'
        }
      },
      default: 'guest'
    }
  }
};
var OrgMemberList = /*#__PURE__*/function () {
  OrgMemberList.$inject = ["$rootScope", "$route", "$location", "$log", "$scope", "orgService", "eventService", "modalService", "userService"];
  /* @ngInject */
  function OrgMemberList($rootScope, $route, $location, $log, $scope, orgService, eventService, modalService, userService) {
    _classCallCheck(this, OrgMemberList);
    this.$rootScope = $rootScope;
    this.$route = $route;
    this.$location = $location;
    this.$log = $log;
    this.orgService = orgService;
    this.eventService = eventService;
    this.modalService = modalService;
    this.userService = userService;
    this.currentUser = userService.getCurrentUser();
    this.roles = ['admin', 'member', 'organizer', 'guest'];
    this.userCanSeeEmails = userService.matchesRoles({
      globalRole: 'superadmin'
    }, {
      globalRole: 'spotme_support'
    });
    this.canToggleUserRole = this.userService.hasPermission('global_actions.toggle_role');
    this.canRemoveHimselfFromOrg = this.userService.hasPermission('org_realms.remove_yourself_from_org');
    this.setFlashMessage = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.loading = true;
    this.searchQuery = '';
    this.$scope = $scope;
    this.originalMembers = [];
    this.members = [];
    this.rolesOptions = this.roles.map(function (role) {
      return {
        id: role,
        text: role.charAt(0).toUpperCase() + role.slice(1)
      };
    });
  }
  return _createClass(OrgMemberList, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$scope.$watch('$ctrl.searchQuery', function (searchQuery) {
        if (searchQuery !== null && searchQuery !== void 0 && searchQuery.length) {
          _this.visibleMembers = _this.members.filter(function (member) {
            var search = member.realname;
            if (_this.userCanSeeEmails) {
              search = "".concat(search, " ").concat(member.email);
            }
            search = search.toLocaleLowerCase();
            var query = _this.searchQuery.toLocaleLowerCase();
            return search.includes(query);
          });
        } else {
          _this.visibleMembers = _this.members;
        }
      });
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this2 = this;
      if (changes.organisation && this.organisation) {
        this.orgId = this.organisation.name;
        this.loading = true;
        this.orgService.getAllOrgMemberUsers(this.organisation.name).then(function (_ref) {
          var data = _ref.data;
          data.forEach(function (member) {
            var _this2$getMemberRole;
            return member._role = (_this2$getMemberRole = _this2.getMemberRole(member)) === null || _this2$getMemberRole === void 0 ? void 0 : _this2$getMemberRole.id;
          });
          _this2.originalMembers = (0, _lodash.cloneDeep)(data);
          _this2.members = data;
          _this2.visibleMembers = _this2.members;
        }, function () {
          return alert('Failed to fetch member list');
        }).finally(function () {
          return _this2.loading = false;
        });
      }
    }
  }, {
    key: "canSetOrgMemberRole",
    value: function canSetOrgMemberRole() {
      return this.userService.hasPermission('access_modification_realms.set_org_member_role', {
        org_id: this.organisation._id
      });
    }

    /* create new users */
  }, {
    key: "canCreateMembers",
    value: function canCreateMembers() {
      return this.userService.hasPermission('global_actions.create_user', {
        org_id: this.organisation._id
      }) || this.canSetOrgMemberRole();
    }
  }, {
    key: "showNewUserModal",
    value: function showNewUserModal() {
      var _this3 = this;
      this.modalService.openModalWithForm(NEW_USER_FORM).then(function (model) {
        return _this3.addOrSetMemberRelation(model);
      });
    }
  }, {
    key: "addOrSetMemberRelation",
    value: function addOrSetMemberRelation(descriptor, form) {
      var _this4 = this;
      var promise, userEmail;
      if (form && form.$invalid || !(descriptor && descriptor.id)) return;
      userEmail = descriptor.id;
      promise = this.orgService.addOrgUserPermission(this.orgId, userEmail, descriptor.role);
      promise.then(function () {
        _this4.setFlashMessage("A new relation was established in ".concat(_this4.orgId, "."));
        return _this4.$route.reload();
      }, function () {
        // user doesn't exist, create it
        // redirect to the to-be-primed user creation form
        _this4.$rootScope.setNavigationWarningMessage(null);
        _this4.$location.search('org', _this4.organisation._id);
        _this4.$location.search('email', userEmail);
        _this4.$location.search('orgRole', descriptor.role);
        _this4.$location.path('/users/new');
        return;
      });
    }
    /* --- */

    /* promote or demote users */
  }, {
    key: "canPromoteMember",
    value: function canPromoteMember(member) {
      return this.canSetOrgMemberRole() && !this.memberHasRole(member, 'admin');
    }
  }, {
    key: "canDemoteMember",
    value: function canDemoteMember(member) {
      return this.canSetOrgMemberRole() && this.memberHasRole(member, 'admin') && member._id !== this.currentUser._id;
    }
  }, {
    key: "memberHasRole",
    value: function memberHasRole(member, role) {
      return member.roles.some(function (membersRole) {
        return membersRole.role === role;
      });
    }
  }, {
    key: "getMemberRole",
    value: function getMemberRole(member) {
      var _this5 = this;
      var orgRoleObj = member.roles.find(function (membersRole) {
        return _this5.roles.includes(membersRole.role);
      });
      return this.rolesOptions.find(function (role) {
        return role.id === (orgRoleObj === null || orgRoleObj === void 0 ? void 0 : orgRoleObj.role);
      });
    }
  }, {
    key: "memberHasRolePermissions",
    value: function memberHasRolePermissions(member, role) {
      return member.roles.some(function (membersRole) {
        return membersRole.role === role;
      }) || this.isRoleInheritedFromOrgRole(member, role);
    }
  }, {
    key: "isRoleInheritedFromOrgRole",
    value: function isRoleInheritedFromOrgRole(member, role) {
      var _this6 = this;
      var orgRoleObj = member.roles.find(function (membersRole) {
        return _this6.roles.includes(membersRole.role);
      });
      var inheritedRoleObj = {
        type: 'account_permission',
        role: role,
        org_id: this.organisation._id
      };
      return this.userService.canAssignRole([orgRoleObj], inheritedRoleObj);
    }
  }, {
    key: "confirmAndPromoteUser",
    value: function confirmAndPromoteUser(member, role) {
      var _this7 = this;
      var username = member.name;
      this.modalService.openConfirm({
        message: "You are changing the role of ".concat(username, " to ").concat(role, ". Are you sure?"),
        okLabel: 'Continue'
      }).then(function () {
        return _this7.addOrSetMemberRelation({
          id: username,
          role: role
        });
      }).catch(function () {
        return member._role = _this7.originalMembers.find(function (m) {
          return m._id === member._id;
        })._role;
      });
    }
  }, {
    key: "getRemoveRoleTitle",
    value: function getRemoveRoleTitle(member, role) {
      return this.isRoleInheritedFromOrgRole(member, role) ? 'This role cannot be removed as it is inherited.' : 'Remove role';
    }
    /* --- */

    /* remove org member */
  }, {
    key: "removeOrgMember",
    value: function removeOrgMember(member) {
      return member._id !== this.currentUser._id && this.userService.hasPermission('org_realms.remove_org_member', {
        org_id: this.organisation._id
      });
    }
  }, {
    key: "canRemoveMember",
    value: function canRemoveMember(member) {
      return this.canRemoveHimselfFromOrg || this.removeOrgMember(member);
    }
  }, {
    key: "confirmAndRemoveUser",
    value: function () {
      var _confirmAndRemoveUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(member) {
        var orgName, memberName, message;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              orgName = this.organisation.display_name;
              memberName = member.realname;
              message = "You are about to remove ".concat(memberName, " from ").concat(orgName, ". It will also revoke access to all workspaces in ").concat(orgName, ".");
              _context.prev = 3;
              _context.next = 6;
              return this.modalService.openConfirm({
                message: message,
                okLabel: 'Remove user'
              });
            case 6:
              return _context.abrupt("return", this.removeUser(member));
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 9]]);
      }));
      function confirmAndRemoveUser(_x) {
        return _confirmAndRemoveUser.apply(this, arguments);
      }
      return confirmAndRemoveUser;
    }()
  }, {
    key: "removeUser",
    value: function () {
      var _removeUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(member) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.orgService.removeMember(this.orgId, member._id);
            case 3:
              this.setFlashMessage("".concat(member.realname, " was removed from ").concat(this.organisation.display_name));
              this.$route.reload();
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              this.setFlashMessage('An error occurred while removing member', 'danger');
              console.error('Error while removing member', _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function removeUser(_x2) {
        return _removeUser.apply(this, arguments);
      }
      return removeUser;
    }()
    /* --- */
    /* mfa phone clearing */
  }, {
    key: "canClearPhone",
    value: function canClearPhone(member) {
      return this.removeOrgMember(member);
    }
  }, {
    key: "showClearPhoneModal",
    value: function () {
      var _showClearPhoneModal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(member) {
        var message, title;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              message = 'Are you sure you want to remove this user\'s phone number? He or she will be informed of this change via email.';
              title = 'Remove this users\'s phone number';
              _context3.prev = 2;
              _context3.next = 5;
              return this.modalService.openConfirm({
                title: title,
                message: message,
                okLabel: 'Remove',
                buttonClass: 'danger'
              });
            case 5:
              return _context3.abrupt("return", this.clearPhone(member));
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 8]]);
      }));
      function showClearPhoneModal(_x3) {
        return _showClearPhoneModal.apply(this, arguments);
      }
      return showClearPhoneModal;
    }()
  }, {
    key: "clearPhone",
    value: function () {
      var _clearPhone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(member) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.orgService.clearPhone(this.orgId, member._id);
            case 3:
              this.setFlashMessage("".concat(member.realname, "'s phone number was removed from their profile"));
              _context4.next = 10;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              this.setFlashMessage('An error occurred while removing the phone number', 'danger');
              console.error('Error while removing phone member', _context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 6]]);
      }));
      function clearPhone(_x4) {
        return _clearPhone.apply(this, arguments);
      }
      return clearPhone;
    }() /* toggle user role */
  }, {
    key: "toggleUserRole",
    value: function toggleUserRole(username, role) {
      var _this8 = this;
      return this.orgService.toggleOrgUserPermission(this.orgId, username, role).then(function () {
        _this8.setFlashMessage("A new relation was established in ".concat(_this8.orgId, "."));
        return _this8.$route.reload();
      }).catch(function (err) {
        alert('An error occurred. Are you sure the target item exists?');
        return _this8.$log.error('Error while adding the relation', err);
      });
    }
  }, {
    key: "confirmAndToggleUsersRole",
    value: function confirmAndToggleUsersRole(member, role) {
      var _this9 = this;
      if (this.isRoleInheritedFromOrgRole(member, role)) return;
      var message = this.memberHasRole(member, role) ? "You are removing the ".concat(role, " role from ").concat(member.name, ". Are you sure?") : "You are adding the ".concat(role, " role to ").concat(member.name, ". Are you sure?");
      this.modalService.openConfirm({
        message: message,
        okLabel: 'Continue'
      }).then(function () {
        return _this9.toggleUserRole(member.name, role);
      });
    }
    /* --- */
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.member-list', ['backstage.services']).component('bsOrgMemberList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-member-list/org-member-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgMemberList
}).name;